var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendEvaluation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 60,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#353C3C",
  strokeWidth: 1.7,
  d: "M46.571 26.394v-8.305L29.482.999H6.702a5.48 5.48 0 0 0-4.028 1.674A5.48 5.48 0 0 0 1.001 6.7v45.549a5.48 5.48 0 0 0 1.673 4.024 5.48 5.48 0 0 0 4.027 1.676l17.515.62c-.653-2.205-.96-4.5-.91-6.8A25.476 25.476 0 0 1 46.57 26.395Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#621726",
  strokeWidth: 1.7,
  d: "M50.244 50.182c-.547 0-1.088.109-1.593.319-.502.2-.965.485-1.37.842l-10.13-5.894q.077-.237.107-.484a3.9 3.9 0 0 0 0-1.042 2.5 2.5 0 0 0-.108-.482l10.133-5.9c.404.357.867.643 1.367.844a4.354 4.354 0 1 0-2.724-4.136v.131q0 .262.035.522.032.246.108.484l-10.133 5.9a4.8 4.8 0 0 0-1.077-.666c-.1-.048-.185-.137-.29-.178a4.275 4.275 0 0 0-4.648.94 4.337 4.337 0 0 0 0 6.11 4.27 4.27 0 0 0 4.644.939c.5-.201.963-.487 1.367-.844l10.137 5.894q-.076.238-.108.484a4.32 4.32 0 1 0 4.307-3.778h-.028"
})), /*#__PURE__*/React.createElement("mask", {
  id: "send-evaluation_svg__a",
  width: 19,
  height: 19,
  x: 28,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M46.571 1H28.147v18.192h18.424z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#send-evaluation_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#353C3C",
  strokeLinecap: "round",
  strokeWidth: 1.7,
  d: "M46.571 18.342H28.997V1"
}))));
export { SvgSendEvaluation as ReactComponent };
export default __webpack_public_path__ + "83fb34ff4a50e0cc6e1d77f592bd133e.svg";